import React from 'react';
import cs from 'classnames';
import css from './index.css';

const TableCheckbox = (props) => (
  <div className={cs(css.label, {[css.checked]: props.checked})} onClick={props.click}>
    <input type='checkbox' name='' id=''/>
    {props.children}
  </div>
);

export default TableCheckbox;



// WEBPACK FOOTER //
// ./src/components/common/TableCheckbox/index.js